import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { Text, TextType } from 'ui-components/components/text';

import FormattedCurrency from '../../../../components/formatted-currency';
import { RateRecommendationBanner } from '../rate-recommendation-banner';
import type { Currency } from '../../../../prop-types/currency-types';

import { messages } from './messages';

import style from '../rate-recommendation.module.less';
import type { FC } from 'react';

type RateShopperRecommendationBannerProps = {
  className?: string;
  theme?: 'light' | 'medium' | 'dark';
  savings: Currency;
  onApply: () => void;
  onDismiss: () => void;
};

export const RateShopperRecommendationBanner: FC<RateShopperRecommendationBannerProps> = ({
  className,
  theme = 'light',
  savings,
  onApply,
  onDismiss,
}) => {
  return (
    <RateRecommendationBanner
      applyButton={
        <Button className={style['rate-comparison-apply-button']} onClick={onApply} theme={THEME_CONSTANTS.white}>
          <FormattedMessage {...messages.recommendationApplyButton} />
        </Button>
      }
      bannerText={
        <Text
          formattedMessageValues={{
            s: (chunks) => <strong>{chunks}</strong>,
            savings: () => (
              <strong>
                <FormattedCurrency currencyCode={savings.code} value={savings.value} />
              </strong>
            ),
          }}
          textType={TextType.Paragraph}
          value={messages.saveWithRateShopper}
        />
      }
      className={className}
      contentClassName={style['single-recommendation-banner-content']}
      onDismiss={onDismiss}
      theme={theme}
    />
  );
};
